<template>
  <div class="btbody">
    <div class="alert" :class="searchState?'alert-primary':'alert-dark'" role="alert">{{searchState?'搜索完成！':'搜索中'}}</div>
    <ol>
      <li v-for="(doc) in docs" :key="doc._id">
        <div class="name">
          <span>
            <a class="magnet-link" :href="doc.magnet">{{doc.name}}</a>
          </span>
        </div>
        <div class="date">
          <span class="badge badge-dark">【日期】：</span>
          {{doc.date}}
        </div>
        <div class="hot">
          <span class="badge badge-dark">【热度】：</span>
          {{doc.hot}}
        </div>
        <div class="size">
          <span class="badge badge-dark">【大小】：</span>
          {{doc.formatSize}}
        </div>
        <div class="magnet cut">
          <span class="badge badge-dark">【磁力链】：</span>
          <a class="magnet-link" :href="doc.magnet">{{doc.magnet}}</a>
        </div>
        <hr />
      </li>
    </ol>
  </div>
</template>
<script>
export default {
  props: ["docs",'searchState']
};
</script>
<style scoped>
div.btbody {
  width: 80%;
  margin: 0 auto;
  /* font-size */
}
a.magnet-link {
  text-decoration: none;
}
.badge {
  font-size: small;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  margin: 0 5px;
}
div {
  margin: 5px 0;
}
div.cut {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.name{
  word-break: break-all;
}
</style>